module.exports = __webpack_public_path__ + "img/35864-042.fafe8f5b.jpg";